import { TipoPrecio } from "./tipo_precio";

export class PrecioAdicional{    
    public constructor(
        public id: number = 0,
        public valor:number = 0,
        public producto_id:String = "",
        public tipo_precio_id:String = "",
        public usuario_id:String = null,
        public editar:boolean = false,

        public tipoprecio: TipoPrecio = new TipoPrecio(),
        public tipo_precio: TipoPrecio = new TipoPrecio(),
    ){}

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/precio_adicional.ts